import { GET_TXT_PUNTOCONTROL, SET_IDTIPO_PUNTOCONTROL } from "../ActionTypes";

const puntoControl = (state, { payload, type }) => {
  switch (type) {
    case SET_IDTIPO_PUNTOCONTROL:
      return {
        ...state,
        puntoControl: {
          ...state.puntoControl,
          error: false,
          idTipo: payload,
        },
      };

    case GET_TXT_PUNTOCONTROL:
      return {
        ...state,
        puntoControl: {
          ...state.puntoControl,
          error: false,
          data: payload,
        },
      };

    default:
      return state;
  }
};

export default puntoControl;
